import React from 'react';
import i18n from '../../i18n/config';

interface CTASectionProps {
  variant?: 'inline' | 'full';
  color?: string;
  className?: string;
}

const CTASection: React.FC<CTASectionProps> = ({ 
  variant = 'full', 
  color,
  className = '' 
}) => {
  if (variant === 'inline') {
    return (
      <div className={`mb-8 ${className}`}>
        <div 
          className="text-center p-6 rounded-lg border-2" 
          style={{ 
            borderColor: color ? `${color}30` : '#3498db30', 
            backgroundColor: color ? `${color}05` : '#3498db05' 
          }}
        >
          <h3 className="text-xl font-semibold text-[#2c3e50] mb-3">
            {i18n.t('loan_types_page.cta.title')}
          </h3>
          <p className="text-gray-600 mb-4">
            {i18n.t('loan_types_page.cta.description')}
          </p>
          <a
            href={`/#${i18n.t('anchor_links.loan_application_form')}`}
            className="inline-flex items-center px-8 py-3 text-lg font-semibold rounded-md text-white transition-all duration-200 hover:opacity-90 shadow-md"
            style={{ backgroundColor: color || '#3498db' }}
          >
            {i18n.t('loan_types_page.cta.button')}
          </a>
        </div>
      </div>
    );
  }

  return (
    <section className={`py-16 bg-gradient-to-br from-[#2c3e50] to-[#3498db] text-white ${className}`}>
      <div className="container mx-auto px-4 text-center">
        <h2 className="text-3xl md:text-4xl font-bold mb-6">
          {i18n.t('loan_types_page.cta.title')}
        </h2>
        <p className="text-xl text-white/90 mb-8 max-w-2xl mx-auto">
          {i18n.t('loan_types_page.cta.description')}
        </p>
        <a
          href={`/#${i18n.t('anchor_links.form')}`}
          className="inline-flex items-center px-8 py-4 bg-[#1abc9c] text-white font-semibold rounded-lg hover:bg-[#16a085] transition-colors duration-300 shadow-lg hover:shadow-xl"
        >
          {i18n.t('loan_types_page.cta.button')}
        </a>
      </div>
    </section>
  );
};

export default CTASection; 